/**
 * True only for absolute http(s) URLs. Use before putting backend- or
 * LLM-influenced URLs (e.g. a cited document's published_url) into an href,
 * so javascript:, data:, vbscript: and other schemes never become links.
 */
export function isSafeHttpUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const { protocol } = new URL(url.trim());
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
}
